module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-254.87ce1c87.svg";